import React, { useEffect, useState } from "react";
import { Button } from "../../../components/ds";
import images from "../../../assets/images";
import SurveyCompletionModal from "./SurveyCompletionModal";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedCategory,
  setSelectedSection,
} from "../../../slices/Admin/survey-CSF.slice";
import { setActiveSurvey } from "../../../slices/signIn.slice";
import { SURVEYS } from "../../../helpers/constants";

const SurveyFooter = ({ questionData, submissionStatus }) => {
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const [isAssessmentComplete, setIsAssessmentComplete] = useState(false);

  const dispatch = useDispatch();
  const { categories, sections, loading, isCSFComplete } = useSelector(
    (state) => state.CSFSurvey
  );

  const saveProgress = () => {
    dispatch(setActiveSurvey(SURVEYS.CRR));
  };

  useEffect(() => {
    if (
      submissionStatus?.question_id &&
      isCSFComplete &&
      !submissionStatus?.has_prev_answer
    ) {
      setIsAssessmentComplete(true);
      setShowCompletionModal(true);
    }
  }, [submissionStatus, isCSFComplete]);

  const handleCancel = () => {
    setShowCompletionModal(false);
  };

  const handleNextClick = () => {
    setShowCompletionModal(false);

    if (questionData?.next_section?.is_new_category) {
      const nextCategory = categories?.find(
        (category) => category.id === questionData?.next_section?.category_id
      );
      dispatch(setSelectedCategory(nextCategory));
    } else {
      const nextSectionId = questionData?.next_section?.id;
      if (nextSectionId) {
        const nextSection = sections.find(
          (section) => section.id === nextSectionId
        );
        dispatch(setSelectedSection(nextSection));
      } else {
        if (!isCSFComplete) {
          setIsAssessmentComplete(false);
          setShowCompletionModal(true);
        } else {
          dispatch(setActiveSurvey(SURVEYS.CRR));
        }
      }
    }
  };

  const modalProps = isAssessmentComplete
    ? {
        icon: <img src={images.Party_Popper_Icon} alt="Celebration Icon" />,
        title: "Congratulations!",
        description:
          "You have successfully completed the Cybrbase CSF 2.0 Pre Assessment.",
        primaryBtnText: "GO TO CRR ASSESSMENT",
        primaryBtnAction: saveProgress,
        secondaryBtnText: "STAY HERE",
        secondaryBtnAction: handleCancel,
      }
    : {
        icon: <img src={images.Warning_Icon} alt="Warning Icon" />,
        title: "Incomplete Assessment",
        description:
          "Please complete all questions in CSF 2.0 to proceed to CRR Assessment.",
        primaryBtnText: "GOT IT",
        primaryBtnAction: handleCancel,
        secondaryBtnAction: handleCancel,
      };

  return (
    <div className="survey-footer-actions">
      <Button
        className="next-goal-btn"
        variant="primary"
        onMouseDown={handleNextClick}
        disabled={loading}
      >
        <span className="next-goal-btn-text">
          {questionData?.next_section?.id ? "NEXT" : "CRR ASSESSMENT"}
        </span>
      </Button>

      <SurveyCompletionModal visible={showCompletionModal} {...modalProps} />
    </div>
  );
};

export default SurveyFooter;
